export function videoEmbed(media) {
  if(!media || media.reviewStatus!=='approved' || media.availabilityStatus!=='available' || !media.embeddingAllowed || !media.rights || !media.reviewedBy || !media.reviewedAt || !media.availabilityCheckedAt || !media.summary || !media.author || !media.language || !media.title || !media.sourceIds?.length) return null;
  try {
    const u=new URL(media.url);
    if(u.protocol!=='https:' || u.username || u.password || !['www.youtube.com','youtube.com','youtu.be'].includes(u.hostname))return null;
    const id=u.hostname==='youtu.be'?u.pathname.slice(1):u.pathname==='/watch'?u.searchParams.get('v'):null;
    if(!/^[A-Za-z0-9_-]{11}$/.test(id||''))return null;
    const start=media.segmentStart??0,end=media.segmentEnd;
    if(!Number.isInteger(start)||start<0||(end!=null&&(!Number.isInteger(end)||end<=start)))return null;
    return `https://www.youtube-nocookie.com/embed/${id}?autoplay=0&start=${start}${end==null?'':`&end=${end}`}`;
  } catch {return null;}
}
export function canPublishTreatment(item) {
  return !!item && ['country','crop','form','labelUrl','registration','checkedAt','target','dose','restrictions'].every(k=>typeof item[k]==='string'&&item[k].trim()) && Number.isFinite(item.waitingDays) && item.waitingDays>=0 && item.status==='approved' && item.currentRegistration===true;
}
